/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import { Route } from 'react-router-dom';
import { RouteComponentProps, SwitchProps } from 'react-router';
import {
  generateQueryParamsFromStringQuery,
  generateQueryParamsFromObjectQuery,
} from '@/utils/helper';
import rootRoutes, { ComponentRoutes } from './rootRoutes';

import {
  checkIfCredentialsIsExsist,
  checkIfTokenIsExsist,
  checkEncryptedSessionLogin,
  checkIsTokenValid,
} from './middleware';

interface MethodRenderProps extends RouteComponentProps, ComponentRoutes {}

const PublicRoute = (props: MethodRenderProps) => {
  const { Component, ...rest } = props;
  return <Component {...rest} />;
};

const PrivateRoute = (props: MethodRenderProps) => {
  const {
    location: { pathname, search },
    Component,
    history,
    isDoctor,
  } = props;
  const [loadingCredential, setLoadingCredential] = useState<boolean>(true);
  const query = generateQueryParamsFromStringQuery(search);
  const beforeEachCheckCredential = async () => {
    setLoadingCredential(true);
    if (!checkIfCredentialsIsExsist()) {
      try {
        await checkEncryptedSessionLogin(query, isDoctor);
        const { credential, ...restOfQuery } = query;
        const newQueryStringWithoutCredential = generateQueryParamsFromObjectQuery(
          restOfQuery
        );
        history.replace(`${pathname}${newQueryStringWithoutCredential}`);
        return;
        // eslint-disable-next-line no-empty
      } catch (error) {}

      try {
        if (!checkIfTokenIsExsist()) throw new Error('token not exsist');
        await checkIsTokenValid(isDoctor);
      } catch (error) {
        history.replace('/patient');
      }
    }
    setLoadingCredential(false);
  };
  useEffect(() => {
    beforeEachCheckCredential();
  }, [pathname, search]);

  if (loadingCredential) {
    return null;
  }
  return <Component {...props} />;
};

const AppRoute = ({ location }: SwitchProps) => {
  const RenderRoute = rootRoutes.map((eachRoutePath: ComponentRoutes) => {
    const {
      Component,
      isNeedAuth,
      meta,
      children,
      isDoctor,
      ...restProps
    } = eachRoutePath;
    return (
      <Route
        key={restProps.path}
        {...{ ...restProps, location }}
        render={(routeComponentProps: RouteComponentProps) => {
          if (isNeedAuth) {
            return (
              <PrivateRoute {...{ ...routeComponentProps, ...eachRoutePath }} />
            );
          }
          return (
            <PublicRoute {...{ ...routeComponentProps, ...eachRoutePath }} />
          );
        }}
      />
    );
  });
  return <>{RenderRoute}</>;
};

const Routing = (props: any) => {
  return <AppRoute {...props} />;
};

export default Routing;
